//var SITE_URL = "https://www.weblinesolutions.net/";
var SITE_URL = window.location.origin;
var ajax_url = SITE_URL +'/wp-admin/admin-ajax.php';
$(document).on('ready', function () {

  //Mobile menu toggle
  if ($(window).width() < 992){
    $('.dd-arrow, .nav-item.dropdown > .nav-link').click(function (e) {
      e.preventDefault(); // Prevent default behavior of links

      // Check if the clicked element is .nav-item.dropdown > .nav-link
      if ($(this).is('.nav-item.dropdown > .nav-link')) {
          // Check if the href attribute is "#"
          if ($(this).attr('href') === '#') {
              // Programmatically trigger the click event on the .dd-arrow
              $(this).siblings('.dd-arrow').trigger('click');
          } else {
              // If href is not "#", allow the page to redirect
              window.location.href = $(this).attr('href');
          }
          return; // Exit to avoid redundant toggling
      }

      // Toggle the dropdown menu and active class for .dd-arrow
      const $dropdownMenu = $(this).siblings('.dropdown-menu');
      $(this).toggleClass('active');
      $dropdownMenu.toggleClass('active');
  });



    // $('.dd-arrow, .nav-item.dropdown > .nav-link').click(function(e){
    //   $(this).next('ul, .dropdown-menu').toggleClass('active');
    //   $(this).toggleClass('active');
    //   return false;
    // });
    $('.nav-heading-no-link').click(function(e){
      $(this).next('.nav-section').toggleClass('active');
      $(this).toggleClass('active');
      return false;
    });
  }

  // Add minus icon for collapse element which is open by default
  $(".collapse.show").each(function () {
    $(this).prev(".card-header").find(".fa").addClass("fa-minus").removeClass("fa-plus");
  });

  // Toggle plus minus icon on show hide of collapse element
  $(".collapse").on('show.bs.collapse', function () {
    $(this).prev(".card-header").find(".fa").removeClass("fa-plus").addClass("fa-minus");
  }).on('hide.bs.collapse', function () {
    $(this).prev(".card-header").find(".fa").removeClass("fa-minus").addClass("fa-plus");
  });

  //Why Webline India Slider
  if (window.matchMedia("(max-width: 767px)").matches) {
      $('.whywebline-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: false,
        cssEase: 'ease-in-out',
        fade: true,
        speed: 1000,
        adaptiveHeight: true
      });
  } else {
  }

  //Industry Slider
  //if (window.matchMedia("(max-width: 767px)").matches) {
    $('.industry-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      autoplay: false,
      speed: 1000,
       responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
        ]
    });
 // } else {
//  }
var url = window.location.href;
var url_array = url.split("/");
var myArrayNew = url_array.filter(function (el) {
  return el != null && el != "";
});
var c_arr = myArrayNew.length;
var case_study_single = url_array[3];
var segment = url.split("/").length - 1 - (url.indexOf("http://"));


  jQuery('.subscribeBtn').click(function(){

        var container=jQuery(this).closest('div.subscribeform_js');
        email = jQuery('.txtEmail',container).val();
        page_history = $('#pageHistory', container).val();
        landing_pageReferrer = $('#landingPageReferrer', container).val();
        //nonce = jQuery(this).data("ajaxnonce");
       var response = grecaptcha.getResponse();
       g_recaptcha_response = response;
       website = jQuery('.website',container).val();

        if (jQuery.trim(email).length == 0) {
           jQuery('.errorMsg',container).html('Please Enter Valid Email ID.');
           return false;
        }

        if (!validateEmailAddress(email)) {
           jQuery('.errorMsg',container).html('Invalid Email ID.');
           return false;

        }

        jQuery.ajax({
            type : 'POST',
            url  : ajax_url,
            data : {
                  action: 'subscribe_newsletter',
                  email: email,
                  website: website,
                  g_recaptcha_response: g_recaptcha_response,
                  pageHistory:page_history,
                  landingPageReferrer:landing_pageReferrer
                  //security:nonce
            },
            beforeSend: function() {
                jQuery('.nbw_loader',container).show();
            },
            success: function(data, textStatus, XMLHttpRequest) {
              jQuery('.errorMsg',container).html("");
              jQuery('.successMsg',container).html("");
                var decode = jQuery.parseJSON(data);
                if(decode.flag == 1)
                {
                    jQuery(".formin",container).fadeOut(600,function(){
                        jQuery(".successMsg",container).html(decode.msg).show();

                    });
                }
                else
                {
                  jQuery('.errorMsg',container).html(decode.msg);
                }
                jQuery('.nbw_loader',container).hide();
            },
            error: function() {
              jQuery('.errorMsg',container).html("");
              jQuery('.successMsg',container).html("");
              jQuery('.errorMsg'.container).html('Something went wrong. Please try again.');
              jQuery('.nbw_loader',container).hide();
            },
        });
      return false;
  });

  var url = window.location.href;
  var url_array = url.split("/");
  var case_study_single = url_array[3];

  var segment = url.split("/").length - 1 - (url.indexOf("http://") == -1 ? 0 : 2);

  // Validate and Download casestudy Functionality
  $('#casestudy_downloadform').validate({

      rules: {
          txtname: {
              required: true
          },
          txtemail: {
              required: true,
              email: true
          }
      },
      required: function() {
          if (grecaptcha.getResponse() == '') {
              return true;
          } else {
              return false;
          }
      },
      submitHandler: function(form) {

          var downloadCaseStudyAjaxurl = '/wp-admin/admin-ajax.php';

          var container = $('#download-casestudy');

          $('.errorMsg_cs', container).html('');
          $('.successMsg_cs', container).html('');
          var isCaptchaValidated = false;
          var response = grecaptcha.getResponse();

          // if(response.length == 0) {
          //     isCaptchaValidated = false;
          //     alert('Please verify that you are a Human.');
          //     return false;
          // } else {
          //     isCaptchaValidated = true;
          // }


          // if (isCaptchaValidated ) {

          user_name = $('#txtname', container).val();
          user_email = $('#txtemail', container).val();
          page_history = $('#pageHistory', container).val();
          landing_pageReferrer = $('#landingPageReferrer', container).val();
          checkSubscribe = $('#checkSubscribe', container).prop('checked');
          post_id = $('.postid', container).val();
          // nonce = $('#wli-nonce', container).val();
          website = $('.website').val();
          g_recaptcha_response = response;
          $.ajax({
              type: 'POST',
              url: downloadCaseStudyAjaxurl,
              data: {
                  action: 'download_casestudy',
                  name: user_name,
                  email: user_email,
                  subscribe: checkSubscribe,
                  website: website,
                  g_recaptcha_response: g_recaptcha_response,
                  postID: post_id,
                  pageHistory:page_history,
                  landingPageReferrer:landing_pageReferrer
              },

              success: function(data, status, XMLHttpRequest) {
                  var decode = $.parseJSON(data);
                  if (decode.status == 1) {
                      $('.successMsg_cs', container).html(decode.message);
                      $('#casestudy_downloadform', container).hide();
                  } else {
                      $('.errorMsg_cs', container).html(decode.message);
                  }

              },
              error: function() {

              },
          });
          return false;
      }
  });

  function validateEmailAddress(email)
  {
        var reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (reg.test(email)){
            return true;
        }
        else{
            return false;
        }
  }

  //cleared form values
  if( $('form#contact').length > 0 ) {
    $('form#contact')[0].reset();
  }

  //Add method for non cyrillic validation
  $.validator.addMethod(
    "nocyrillic",
    function(value, element) {
      var pattern = new RegExp(/[\u0400-\u04FF]/);
      return ! pattern.test(value);
    },
    "Please enter latin characters only."
  );

//Email Validation
$.validator.addMethod("validate_email", function(value, element) {
  return this.optional( element ) || /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test( value );
}, 'Please enter a valid email address.');

//Phone Validation
$.validator.addMethod("customPattern", (function(e, t) {
  return this.optional(t) || /^[0-9()+\-\s]*$/.test(e)
}), "Invalid phone number format.");

  //Contact form validation
  $('#contact').validate({
      rules: {
        name: {
              required: true,
              maxlength:100,
              normalizer: function( value ) {
                return $.trim( value );
              },
              nocyrillic: true
          },
          w_email: {
              required: true,
              validate_email: true,
              normalizer: function( value ) {
                return $.trim( value );
              }
          },
          phone: {
              //required: true,
              minlength: 10,
              maxlength: 20,
              normalizer: function( value ) {
                  return $.trim(value);
              },
              customPattern: true
          },
          projdescription: {
              required: true,
              maxlength:1000,
              normalizer: function( value ) {
                return $.trim( value );
              },
              nocyrillic: true
          }
      },
      errorPlacement: function(error,element) {
          return true;
      },
      highlight: function(element) {
          $(element).parent('div').addClass('error');
      },
      unhighlight: function(element) {
          $(element).parent('div').removeClass('error');
      },
      onfocusout: function(element)
      {
        tmpval = $(element).val().trim();
        if (tmpval == '') {
          $(element).siblings('.formlabel').removeClass('labelup');
        } else {
          $(element).siblings('.formlabel').addClass('labelup');
        }
        return true;
      }
  });

  //Initialize sticky sidebar
  var widgets = $('.wli-sticky-sidebar .widget_custom_html');
  if( widgets.length > 0 ) {
    widgets.each(function(i) {

        //Check if no of widget as sticky
        if (i == 0) {
            var widget = $(widgets[i]);
            var next = widgets[i + 1];

            var headerHeight = $('#header').outerHeight(true);
            widget.scrollToFixed({
                marginTop: headerHeight + 30,
                limit: function() {
                    var limit = 0;
                    if (next) {
                        limit = $(next).offset().top - $(this).outerHeight(true);
                    } else {
                        limit = $('.wli-sticky-sidebar-stop').offset().top - $(this).outerHeight(true) - 30;
                    }
                    return limit;
                },
                //minWidth: 769,
                zIndex: 999,
                //removeOffsets: true
            });
        }
    });
  }

  // Back to top
  $(window).scroll(function () {
    if ($(this).scrollTop()) {
      $('#toTop').fadeIn();
    } else {
      $('#toTop').fadeOut();
    }
  });

  $("#toTop").click(function (e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, 800);
  });

  //Common accordians
  $('.accordian-title').click(function(){
    $(this).children('i').toggleClass('fa-plus fa-minus');
    $(this).parent().parent().siblings().find('.accordian-title').children('i').removeClass('fa-minus').addClass('fa-plus');
  });

  //For Career Page
  if( $(".applyNow").length > 0 ) {
    $(".applyNow").click(function() {
        $('html,body').animate({
            scrollTop: $("#jobsSection").offset().top - 70},
        'slow');
    });
  }

  // Clients Logo left-to-right
  if( $('.client-logo').length > 0 ) {
    $('.client-logo').slick({
        slidesToShow: 8,
        slidesToScroll:1,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 0,
        arrows: false,
        speed:2000,
        dots: false,
        draggable:false,
        touchMove:false,
        swipeToSlide:false,
        swipe:false,
        pauseOnHover: false,
        cssEase: 'linear',
        infinite: true,
        rtl:true,
        responsive: [{
            breakpoint: 768,
            settings: {
              slidesToShow: 6,
              slidesToScroll:1,
            }
        }, {
            breakpoint: 520,
            settings: {
              slidesToShow: 4,
              slidesToScroll:1,
            }
        }]
    });
  }

  // Team photos carousel left
  if( $('.team-photos-left').length > 0 ) {
    $('.team-photos-left').slick({
      slidesToShow: 20,
      slidesToScroll:1,
      autoplay: true,
      autoplaySpeed: 0,
      arrows: false,
      speed:3000,
      dots: false,
      draggable:false,
      touchMove:false,
      swipeToSlide:false,
      swipe:false,
      pauseOnHover: false,
      cssEase: 'linear',
      infinite: true,
      rtl:true,
      responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 6,
            slidesToScroll:1,
          }
      }, {
          breakpoint: 520,
          settings: {
            slidesToShow: 4,
            slidesToScroll:1,
          }
      }]
    });
  }

  // Team photos carousel right.
  if( $('.team-photos-right').length > 0 ) {
    $('.team-photos-right').slick({
      slidesToShow: 20,
      slidesToScroll:1,
      autoplay: true,
      autoplaySpeed: 0,
      arrows: false,
      speed:3000,
      dots: false,
      draggable:false,
      touchMove:false,
      swipeToSlide:false,
      swipe:false,
      pauseOnHover: false,
      cssEase: 'linear',
      infinite: true,
      rtl:false,
      responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 6,
            slidesToScroll:1,
          }
      }, {
          breakpoint: 520,
          settings: {
            slidesToShow: 4,
            slidesToScroll:1,
          }
      }]
    });
  }

});//End Document Ready



//Current Year
document.getElementById('copyrightyear').appendChild(document.createTextNode(new Date().getFullYear()))

//Tooltip 21 Dec 2020 added by Brij
$(function () {
  $('[data-toggle="tooltip"]').tooltip()
});

//Javascript event to handle lazysizes load
document.addEventListener('lazybeforeunveil', function(e){

  //Get lazy load action
  var lazyAction = jQuery(e.target).data('lazyaction');

  if( lazyAction == 'case-studies' ) {

    $(".success-stories-section").each( function(){
      var $obj = $(this);
      var limit = $obj.data('limit');
      var tech_ids =  $obj.data('id');
      jQuery.ajax({
        url : ajax_url,
        type : 'post',
        data : {
          action : 'get_portfolio_casestudy_slider_custom',
          limit : limit,
          tech_ids : tech_ids,
        },
        beforeSend: function(){
          $obj.html('<div class="loading-image mb-4 text-center"><img data-src="/assets/img/ajax-loader.gif" width="32" height="32" alt="Loading Portfolios" class="lazyload"></div>');
          $obj.find('.loading-image').show();
        },
        complete: function(){
          $obj.find('.loading-image').hide();
        },
        success : function( response ) {
          $obj.html(response);
        }

      });

    });

  } else if( lazyAction == 'recent-blog' ) {

        $(".recent-post-wrapper").each( function(){
          var $obj = $(this);
          var limit = $obj.data('limit');
          var tech_ids =  $obj.data('id');
          jQuery.ajax({
            url : ajax_url,
            type : 'post',
            data : {
              action : 'get_blogs_slider',
              limit : limit,
              tech_ids : tech_ids,
            },
            beforeSend: function(){
              $obj.html('<div class="loading-image mb-4 text-center"><img data-src="/assets/img/ajax-loader.gif" width="32" height="32" alt="Loading Portfolios" class="lazyload"></div>');
              $obj.find('.loading-image').show();
            },
            complete: function(){
              $obj.find('.loading-image').hide();
            },
            success : function( response ) {
              $obj.html(response);
            }

          });

        });

      }
    });



//Javascript event to handle lazysizes load titbits section
document.addEventListener('lazybeforeunveil', function(e){

  //Get lazy load action
  var lazyAction = jQuery(e.target).data('lazyaction');

  if( lazyAction == 'titbits' ) {

    $(".titbits-items").each( function(){
      var $obj = $(this);
      var limit = $obj.data('limit');
      var tech_ids =  $obj.data('tech');

      jQuery.ajax({
        url : ajax_url,
        type : 'post',
        data : {
          action : 'get_titbits_slider',
          limit : limit,
          tech_ids: tech_ids
        },
        beforeSend: function(){
          $obj.html('<span class="text-center">Loading...</span>');
          //$obj.find('.loading-image').show();
        },
        complete: function(){
          //$obj.find('.loading-image').hide();
          // Initialize Slick slider
          $('.titbits-items').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 0, // For continuous scrolling
            speed: 35000, // Adjust this for the desired scrolling speed
            cssEase: 'linear',
            infinite: true,
            variableWidth: true,
            arrows: false, // Hide arrows
            swipe: true, // Enable swipe if needed
            pauseOnHover: false, // Set to false to avoid Slick's default behavior
            //rtl: true // Add this for Hebrew or RTL languages
          });
        },
        success : function( response ) {
          $obj.html(response);
        }

      });

    });

  }
  if( lazyAction == 'industries' ) {

    $(".industry-section").each( function(){
      var $obj = $(this);
      var limit = $obj.data('limit');
      var tech_ids =  $obj.data('tech');
      var lang = document.documentElement.lang || 'en';
      var wpmlLang = lang.split('-')[0].toLowerCase();

      jQuery.ajax({
        url : ajax_url,
        type : 'post',
        data : {
          action : 'get_industries',
          limit : limit,
          tech_ids: tech_ids,
          lang: wpmlLang
        },
        beforeSend: function(){
          $obj.html('<span class="text-center">Loading...</span>');
          //$obj.find('.loading-image').show();
        },
        success : function( response ) {
          $obj.html(response);
        }
      });
    });
  }
});


//Extra sticky nav for active and scroll
var h_height = $('#header').height() + $('#stickytypeheader').height() + 40;
var h_height1 = $('#header').height() + $('#stickytypeheader').height();
$(document).ready(function () {
    //smoothscroll
    if ($(".scrollspy-nav").length) {
    function onScroll(event){
        var scrollPos = $(document).scrollTop();

        $('.scrollspy-nav a').each(function () {
            var currLink = $(this);
            var refElement = $(currLink.attr("href"));
            if (refElement.position().top <= (scrollPos + h_height) && refElement.position().top + refElement.height() > (scrollPos + h_height)) {
                $('.scrollspy-nav a').removeClass("active");
                currLink.addClass("active");
            }
            else{
                currLink.removeClass("active");
            }
        });
      }

    $(document).on("scroll", onScroll);
    $('.scrollspy-nav a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        $('.scrollspy-nav a').each(function () {
            $(this).removeClass('active');
        })
        $(this).addClass('active');

        var target = this.hash,
            menu = target;
        $target = $(target);
        $('html, body').stop().animate({
            'scrollTop': $target.offset().top - h_height1
        }, 500, 'swing', function () {
        });
    });

    var s = $(".scrollspy-nav ");
    var pos = s.position();
    $(window).scroll(function() {
    var windowpos = $(window).scrollTop();
    if (windowpos >= pos.top){
      s.addClass("fixed-header");
    } else {
      s.removeClass("fixed-header");
    }
    });
    }

    // Check and replace all social URLs
    if( $('.wli-social-btns a').length > 0 ) {
      var currURL = window.location.href;
      $('.wli-social-btns a').each(function() {
          var link = $(this).attr('href');
          link = link.replace('[URL]', currURL);
          $(this).attr('href', link);
      });
    }


    //Function to creating heading list
    $.fn.headingList = function(options) {
      'use strict';
      options = $.extend({
        target: 'body',
        scrollSpeed: 500,
        prefix: '&nbsp;&nbsp;'
      }, options);

      var htag = $(
        //options.target + ' h1,' +
        options.target + ' h2,' +
        options.target + ' h3,' +
        options.target + ' h4,' +
        options.target + ' h5,' +
        options.target + ' h6'
      );

      var anchorPrefix = 'wli-heading-';
      var html = '<ul>';
      var cnt = 1;

      htag.each(function() {
        var headingInt = parseInt($(this).prop("tagName").slice(1));
        var anchor = anchorPrefix + cnt;
        $(this).attr('id', anchor);

        html += '<li class="li-depth-'+ (headingInt - 1) +'"><a href="#' + anchor + '">';
        $.each(new Array(headingInt - 1),function(i){
          html += options.prefix;
        });
        html += $(this).html();
        html += '</a></li>'

        cnt++;
      });
      html += '</ul>';

      this.html(html);

      this.find('a[href^="#' + anchorPrefix + '"]').click(function() {
        var href = $(this).attr("href");
        var scrollTarget = $(href === "#" || href === "" ? 'html' : href);
        var position = scrollTarget.offset().top -100;
        $('body,html').animate({
          scrollTop: position
        }, options.scrollSpeed, 'swing');
        return false;
      });

      return this;
  };

  //Create blog posts auto heading list
  if( $("#wli-heading-list").length > 0 ) {
      $("#wli-heading-list").headingList({
          target: '.post-details',
          scrollSpeed: 500,
          prefix: '',
      });
  }

  // Blog Detail active state of Table of content on scroll
  $(window).scroll(function() {
      $('#wli-heading-list a').removeClass('active');
      var scrollDistance = $(window).scrollTop();
      var bodywrap = $('.post-details');
      var all = bodywrap.find("h2, h3, h4, h5, h6");
      all.each(function(i) {
              if ($(this).position().top <= scrollDistance) {
                      $('#wli-heading-list a.active').removeClass('active');
                      $('#wli-heading-list a').eq(i).addClass('active');
              }
      });
  })
.scroll();


});


// Sticky clients logo start
var isScrolledIntoView = function(elem) {

  var $elem = $(elem);
  var $main = $('.page-content');
  var $ClientLogo = $('#ClientLogo');
  var $window = $(window);

  var docViewTop = $window.scrollTop();
  var docViewBottom = docViewTop + $window.height();


  var elemTop = $elem.offset().top;
  var mainTop = $main.height();
  var ClientLogoHieght= $ClientLogo.height();
  var elemBottom = elemTop + $elem.height();
  return ((docViewTop >=(mainTop- $window.height() + ClientLogoHieght)) ); //&& (elemTop >= docViewTop)
}

// Sticky clients logo end


//carousel slider use mobile left/right swipe Start
$('.carousel').on('touchstart', function(event){
  const xClick = event.originalEvent.touches[0].pageX;
  $(this).one('touchmove', function(event){
      const xMove = event.originalEvent.touches[0].pageX;
      const sensitivityInPx = 5;

      if( Math.floor(xClick - xMove) > sensitivityInPx ){
          $(this).carousel('next');
      }
      else if( Math.floor(xClick - xMove) < -sensitivityInPx ){
          $(this).carousel('prev');
      }
  });
  $(this).on('touchend', function(){
      $(this).off('touchmove');
  });
});
//carousel slider use mobile left/right swipe End

//Page Track Starts
function setSessionCookie(name, value) {
  document.cookie = name + "=" + value + "; path=/; expires=0";
}

function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Page Track Start
function trackPageVisit() {
  let history = JSON.parse(getCookie('pageHistory') || '[]');
  const currentPage = window.location.href;

  if (!history.includes(currentPage)) {
      history.push(currentPage);
      setSessionCookie('pageHistory', JSON.stringify(history)); // Session cookie (expires when browser closes)
  }

  let referrer = getCookie('landingPageReferrer');
  if (!referrer) {
      referrer = document.referrer || 'direct';
      setSessionCookie('landingPageReferrer', JSON.stringify(referrer)); // Session cookie (expires when browser closes)
  }
}

trackPageVisit();

if (document.getElementById('pageHistory')) {
  document.getElementById('pageHistory').value = getCookie('pageHistory');
}
if (document.getElementById('landingPageReferrer')) {
  document.getElementById('landingPageReferrer').value = getCookie('landingPageReferrer');
}
// Page Track Ends

/* Modal CTA Start */
$(window).on('load', function () {
  const modals = [
    { key: 'modalDismissed', modalId: '#exit-intent-modal-general', buttonClass: '.btn-general' },
    { key: 'modalDismissedOne', modalId: '#exit-intent-modal-one', buttonClass: '.btn-one' },
    { key: 'modalDismissedTwo', modalId: '#exit-intent-modal-two', buttonClass: '.btn-two' },
    { key: 'modalDismissedThree', modalId: '#exit-intent-modal-three', buttonClass: '.btn-three' },
  ];

  const getSessionCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  const setSessionCookie = (name, value) => {
    document.cookie = `${name}=${value}; path=/`;
  };

  const showModal = (modalId) => {
    $(modalId).modal('show');
  };

  const dismissModal = (key, modalId) => {
    setSessionCookie(key, 'true');
    $(modalId).modal('hide');
  };

  modals.forEach(({ key, modalId, buttonClass }) => {
    if (!getSessionCookie(key)) {
      setTimeout(function () {
        showModal(modalId);
      }, 15000);
    }

    $(modalId).on('click', `.close, ${buttonClass}`, function () {
      dismissModal(key, modalId);
    });
  });
});

/* Modal CTA End */

/* Cookie banner JS Starts */
$(window).on('load', function () {
  const okay_btn = document.getElementById('okay-btn');
  const cookie_banner = document.getElementById('cookie-banner');

  if (okay_btn) {
      okay_btn.addEventListener('click', function() {
        cookie_banner.classList.replace('d-flex', 'd-none');
        var expiryDate = new Date();
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);
        document.cookie = "cookiesAccepted=true; expires=" + expiryDate.toUTCString() + "; path=/";
      });
  }

  function isCookieSet(cookieName) {
    const cookies = document.cookie;
    return cookies.includes(`${cookieName}=true`);
  }

  if(cookie_banner){
    if (isCookieSet('cookiesAccepted')) {
      cookie_banner.classList.replace('d-flex', 'd-none');
    } else {
      cookie_banner.classList.replace('d-none', 'd-flex');
    }
  }

  const cookie_icon = document.getElementById('cookie-icon');
  const cookie_banner_icon = document.getElementById('cookie-banner-icon');
  const okay_btn_icon = document.getElementById('okay-btn-icon');

  if (cookie_icon) {
    cookie_icon.addEventListener('click', function() {
      cookie_icon.style.display = 'none';
      cookie_banner_icon.classList.replace('d-none', 'd-flex');
    });
  }

  if (okay_btn_icon) {
    okay_btn_icon.addEventListener('click', function() {
      cookie_banner_icon.classList.replace('d-flex', 'd-none');
      var expiryDate = new Date();
      expiryDate.setFullYear(expiryDate.getFullYear() + 1);
      document.cookie = "cookiesAccepted=true; expires=" + expiryDate.toUTCString() + "; path=/";
    });
  }

  if(cookie_icon){

    if (isCookieSet('cookiesAccepted')) {
      cookie_icon.style.display = 'none';
    } else {
      cookie_icon.style.display = 'flex';
    }
  }

});

/* Cookie banner JS Ends */


/* Software Project Discovery Tool JS Starts */

var continue_discovery_process = document.getElementById('continue_discovery_process');
if (continue_discovery_process){
document.getElementById('continue_discovery_process').addEventListener('click', function(e) {
  e.preventDefault();

  const techBackground = document.querySelector('input[name="techBackground"]:checked')?.nextElementSibling?.innerText;
  const estimationType = document.querySelector('input[name="estimationType"]:checked')?.nextElementSibling?.innerText;
  const project_desc = document.getElementById('business').value;
  const page_history = document.getElementById('pageHistory').value;
  const landing_page_referrer = document.getElementById('landingPageReferrer').value;

  if (!techBackground || !estimationType || !project_desc.trim()) {
      document.querySelectorAll('.required').forEach(el => el.classList.remove('d-none'));
      return;
  }

  const formData = {
      techBackground,
      estimationType,
      project_desc,
      page_history,
      landing_page_referrer,
  };

  const jsonString = JSON.stringify(formData);
  const base64Encoded = btoa(unescape(encodeURIComponent(jsonString)));

  window.location.href = 'https://wpe.weblineindia.com/?data=' + base64Encoded;
});
}
/* Software Project Discovery Tool JS Ends */

/*Language switcher JS starts*/
  $(window).on('load', function () {
  const currentLangFull = document.documentElement.lang || 'en';
  let currentLangCode = currentLangFull.split('-')[0].toLowerCase();

  const langFixMap = {
    'nb': 'no'
  };
  currentLangCode = langFixMap[currentLangCode] || currentLangCode;

  const alternateLinks = document.querySelectorAll('link[rel="alternate"][hreflang]');
  const langMap = new Map();

  alternateLinks.forEach(link => {
    const langCode = link.getAttribute('hreflang');
    let href = link.getAttribute('href');

    if (langCode.toLowerCase() === 'x-default') return;

    if (location.hostname.includes('wli')) {
      href = href.replace(/^https:/, 'http:');
    }

    if (!langMap.has(langCode)) {
      langMap.set(langCode, href);
    }
  });

  const currentLangDisplay = document.getElementById('currentLangDisplay');
  const langOptions = document.getElementById('langOptions');
  const customDropdown = document.getElementById('customLangDropdown');

  // Show current language
  currentLangDisplay.textContent = currentLangCode.toUpperCase();
  currentLangDisplay.classList.add(`lang-${currentLangCode}`);

  let hasOtherLanguages = false;

  // Populate dropdown
  if (langMap.size > 0) {
    langMap.forEach((url, code) => {
      const shortCode = code.split('-')[0].toLowerCase();
      if (shortCode === currentLangCode) return;

      const li = document.createElement('li');
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.textContent = shortCode.toUpperCase();
      anchor.classList.add(`lang-${shortCode}`);
      li.appendChild(anchor);
      langOptions.appendChild(li);
      hasOtherLanguages = true;
    });
  }

  // Always show switcher box
  customDropdown.style.opacity = '1';

  // Only add hover effect if there are other language options
  if (hasOtherLanguages) {
    customDropdown.addEventListener('mouseenter', function () {
      langOptions.classList.remove('d-none');
    });
    customDropdown.addEventListener('mouseleave', function () {
      langOptions.classList.add('d-none');
    });
  }
});


/*Language switcher JS ends*/


